import { useHistory } from "react-router";
import HeaderBar from "../../../components/header/headerBar";
import SelectFeild from "../../../components/select/selectField";
import Input from "../../../components/textfield/input";
import {
  Textarea,
  TextBox,
} from "../../../components/textfield";
import { useEffect, useState } from "react";
import { numberWithCommas } from "../../../helpers/functions";
import MainButton from "../../../components/button/mainButton";
import EmptyModel from "../../../components/modal/emptyModal";
import { SearchField } from "../../../components/textfield";
import "../../../assets/styles/admin/usergroup.scss";
import Button from "../../../components/button/Button";

import {
  Table,
  Badge,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Typography,
  Radio,
  Checkbox,
  InputNumber,
  Modal,
  Form,
  Spin,
  message,
} from "antd";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import styled from 'styled-components'
import Counter from "../../../components/counter/counter";
interface ParamsType {
  id: string;
  mode: string;
}
const ReplyApprover = () => {
  const { id, mode } = useParams<ParamsType>();
  const { Option } = Select;
  const { Text } = Typography;
  const { confirm } = Modal;
  const history = useHistory();
  const [data, setData] = useState<any>({
    code: "",
    requestDate: moment().format(),
    dateReceive: moment().format(),
    stockLocation: "",
  });
  const [isOpen1, setIsOpen1] = useState(false);
  const [productItem, setProductItem] = useState<any>([]);
  const [selectItem, setselectItem] = useState<any>([]);
  const [unitList, setUnitList] = useState<any>([]);
  const [supplier, setSupplier] = useState<any>([]);
  const [payment, setPayment] = useState<any>([]);
  const [branches, setBranches] = useState<any>([]);
  const [stockLocations, setStockLocations] = useState<any>([]);


  const ChangRender = styled.div``
  const display = true;
  const columns = [
    {
      title: (<>ลำดับ<br />No.</>),
      align: "center" as "center",
      width: "100px",
      render: (text: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      key: "code",
      title: (<>รหัส<br />Code No.</>),
      dataIndex: "code",
      align: "center" as "center",
    },
    {
      key: "name",
      title: <>ชื่อ<br />Name</>,
      dataIndex: "name",
      align: "center" as "center",

    },
    {
      key: "unit",
      title: <>หน่วยที่ขอ<br />Unit Request</>,
      dataIndex: "unit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return (
          <Select
            className="antd-Selected col-12"
            showSearch
            suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
            defaultValue={record.unit}
            onChange={(val: string) => {
              selectItem[index]["unit"] = val;
              setselectItem([...selectItem])
            }}
            options={record.unitList}
            disabled={display}
          />
        )
      },
    },
    {
      key: "qty",
      title: (<>จำนวนที่ขอ<br />QTY Request</>),
      dataIndex: "qty",
      align: "center" as "center",
      width: "200px",
      render: (text: any, record: any, index: any) => {
        return (
          <Counter
            defaultValue={record.qty}
            length={1}
            changeValue={(value) => {
              selectItem[index]["qty"] = value;
              setselectItem([...selectItem])
            }}
            disabled={display}
            fixed={false}
          />
        )
      }
    },
    {
      key: "unitReply",
      title: <>หน่วยที่ตอบกลับ<br />Unit Reply</>,
      dataIndex: "unitReply",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return (
          <Select
            className="antd-Selected col-12"
            showSearch
            suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
            defaultValue={record.unitReply}
            onChange={(val: string) => {
              selectItem[index]["unitReply"] = val;
              selectItem[index]["qtyReply"] = 0;

              if (record.unit === val) {
                record.list = record.qty
              } else {
                axios.get(`/stock-products/${record._id}`).then((res: any) => {
                  let { data } = res.data;
                  let dataUnit = 0;
                  let lastUnit = 0;
                  let qtyUnit = 0;
                  let qtySubUnit = 0;
                  let qtySubUnit2 = 0;
                  console.log(data)
                  if (data.unit === val) dataUnit = 3;
                  if (data.subUnit === val) dataUnit = 2;
                  if (data.subUnit2 === val) dataUnit = 1;

                  if (data.unit === record.unit) lastUnit = 3;
                  if (data.subUnit === record.unit) lastUnit = 2;
                  if (data.subUnit2 === record.unit) lastUnit = 1;

                  switch (lastUnit) {
                    case 3:
                      qtyUnit = record.qty;
                      qtySubUnit = record.qty * data.totalPricePerSubUnit
                      qtySubUnit2 = (record.qty * data.totalPricePerSubUnit) * data.totalPricePerSubUnit2;
                      record.list = qtyUnit;
                      break;
                    case 2:
                      qtyUnit = 0;
                      qtySubUnit = record.qty
                      qtySubUnit2 = (record.qty * data.totalPricePerSubUnit) * data.totalPricePerSubUnit2;
                      record.list = qtySubUnit;
                      break;

                    case 1:
                      qtyUnit = 0;
                      qtySubUnit = 0
                      qtySubUnit2 = record.qty;
                      record.list = qtySubUnit2;
                      break;

                    default:
                      break;
                  }
                  switch (dataUnit) {
                    case 3:
                      record.list = qtyUnit;
                      selectItem[index]["list"] = qtyUnit;
                      break;
                    case 2:
                      record.list = qtySubUnit;
                      selectItem[index]["list"] = qtySubUnit;
                      break;

                    case 1:
                      record.list = qtySubUnit2;
                      selectItem[index]["list"] = qtySubUnit2;
                      break;

                    default:
                      break;
                  }
                  setselectItem([...selectItem])
                });
              }
              setselectItem([...selectItem])
            }}
            options={record.unitList}
          />
        )
      },
    },
    {
      key: "qtyReply",
      title: (<>จำนวนตอบกลับ<br />QTY Reply</>),
      dataIndex: "qtyReply",
      align: "center" as "center",
      width: "200px",
      render: (text: any, record: any, index: any) => {
        return (
          <>
            <Counter
              defaultValue={record.qtyReply}
              length={1}
              max={record.list}
              changeValue={(value) => {
                selectItem[index]["qtyReply"] = value;
                setselectItem([...selectItem])
              }}
              fixed={false}
            />
            {/* {record.list} */}
          </>

        )
      }
    },
  ];

  useEffect(() => {
    getProduct();
    getData();
    getUnits();
    getSupplier();
    getPayment();
    getBranches();
    getStockLocations();
  }, []);

  const getProduct = () => {
    axios.get(`/stock-products/map`).then((res) => {
      setProductItem(res?.data?.data)
    });
  };
  const getData = () => {
    axios.get(`/stock-requests/mockup/${id}`).then((res) => {
      setData(res?.data);
      setselectItem(res?.data?.productList.map((item: any) => {
        return {
          ...item,
          list: item.qty
        }
      }))
    });
  };
  const getUnits = () => {
    axios.get(`/stock-product-units`).then((res) => {
      setUnitList(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.name
        }
      }))
    });
  };
  const getBranches = () => {
    axios.get(`/branches`).then((res) => {
      setBranches(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.name
        }
      }))
    });
  };
  const getStockLocations = () => {
    axios.get(`/stock-locations`).then((res) => {
      setStockLocations(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.name,
        }
      }))
    });
  }

  const getSupplier = () => {
    axios.get(`/supplier`).then((res) => {
      setSupplier(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.supplierName
        }
      }))
    });
  };
  const getPayment = () => {
    axios.get(`/payments`).then((res) => {
      const { data } = res;
      setPayment(data.filter((i: any) => i.format === "payment").map((k: any) => ({
        value: k?._id,
        label: k?.name
      })));
    });
  }
  const approver = () => {
    axios.patch(`/stock-requests/approver/${id}`).then((res) => {
      window.location.reload();
    });
  }
  const disapproved = () => {
    axios.patch(`/stock-requests/disapproved/${id}`).then((res) => {
      window.location.reload();
    });
  }

  return (
    <>
      <HeaderBar title="REPLY" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <div className="create-page">
          <div className="title-header">
            <h3>รายการจ่าย/Reply</h3>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="เลขที่ใบขอซื้อ/PR No."
                className="p-0"
                value={data.requestNumber}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">วันที่ขอ/Date Request</div>
              </div>
              <ChangRender>
                <DatePicker
                  placeholder="mm/dd/yyyy"
                  format="DD-MM-YYYY"
                  style={{
                    height: "auto",
                    width: "100%",
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "2px solid #d9d9d9",
                  }}
                  defaultValue={moment(data?.requestDate)}
                  onChange={(e: any) => {
                    setData({ ...data, requestDate: e.format() })
                  }}
                  disabled={display}
                /></ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">ประเภทคำขอ/Type Request</div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.requestType}
                  onChange={(val: string) => setData({ ...data, requestType: val })}
                  options={[
                    {
                      value: "เบิกสาขา/Request  Branch",
                      label: "เบิกสาขา/Request  Branch"
                    },
                    {
                      value: "ส่งคืนสาขา/Return Branch",
                      label: "ส่งคืนสาขา/Return Branch"
                    },
                    {
                      value: "เบิกวัสดุสิ้นเปลือง/Request  Consumables",
                      label: "เบิกวัสดุสิ้นเปลือง/Request  Consumables"
                    },
                    {
                      value: "เบิกใช้ในสาขา/Request Inside Branch",
                      label: "เบิกใช้ในสาขา/Request Inside Branch"
                    }
                  ]}
                  disabled={display}
                />
              </ChangRender>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">จากสาขา/Branch From  </div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.fromBranch}
                  onChange={(val: string) => setData({ ...data, fromBranch: val })}
                  options={branches}
                  disabled={display}
                />
              </ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">จากคลังสินค้า/Warehouse From</div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.fromStockLocation}
                  onChange={(val: string) => setData({ ...data, fromStockLocation: val })}
                  options={stockLocations}
                  disabled={display}
                />
              </ChangRender>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">ไปสาขา/Branch Request</div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.goBranch}
                  onChange={(val: string) => setData({ ...data, goBranch: val })}
                  options={branches}
                  disabled={display}
                />
              </ChangRender>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="input col-12" style={{ height: "auto" }}>
                <div className="title-input">ไปคลังสินค้า/Warehouse Request</div>
              </div>
              <ChangRender>
                <Select
                  className="antd-Selected col-12"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.toStockLocation}
                  onChange={(val: string) => setData({ ...data, toStockLocation: val })}
                  options={stockLocations}
                  disabled={display}
                />
              </ChangRender>

            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <Input
                className="col-12"
                title="หมายเหตุ/Remark"
                type="text"
                placeholder=""
                value={data.Remark}
                onChange={(e: any) => setData({ ...data, Remark: e.target.value })}
                disabled={display}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7} style={{
              display: 'grid',
              alignItems: 'end'
            }}>
              <Checkbox checked={data.urgent || false} onChange={(e: any) => setData({ ...data, urgent: e.target.checked })} disabled={display}>เร่งด่วน/Urgent</Checkbox>
            </Col>
          </Row>
        </div>


        <div className="create-page mt-4">
          <div className="title-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <h3>รายการสินค้า/Product List</h3>
            {
              !display &&
              <Button
                title="เลือกรายการ/ADD"
                width={175}
                onClick={() => setIsOpen1(true)}
              >
              </Button>
            }

          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={24} lg={24}>
              <ChangRender>
                {
                  selectItem &&
                  <Table
                    columns={columns}
                    dataSource={selectItem}
                    bordered
                    scroll={{ x: "max-content" }}
                    rowKey="_id"
                    onChange={(...args) => console.log(...args)}
                  />
                }
              </ChangRender>
            </Col>
          </Row>
        </div>

        <div className="create-page mt-4">
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={7} lg={7}>
              <Row
                justify="space-between"
                style={{
                  marginTop: "10px",
                }}
              >
                <Col xs={24} sm={24} md={12} lg={12}>
                  สถานะ/Status
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <div
                    className={`${data.status === "Pending" || !data.status
                      ? "pending-status"
                      : data.status === "Approved"
                        ? "success-status"
                        : "close-status"
                      }`}
                  >
                    {data.status || "Pending"}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={7} lg={7}>
              {data.status === "Approved" &&
                <TextBox
                  title="ผู้อนุมัติ/Approver By"
                  className="p-0"
                  value={data?.requestApproved?.displayName}
                />}
            </Col>
            <Col xs={24} sm={24} md={7} lg={7}>
              <TextBox
                title="ผู้สร้างคำขอ/Request By"
                className="p-0"
                value={data?.requestBy?.displayName}
              />
            </Col>
          </Row>
        </div>
        {
          data.status !== "Approved" && data.status !== "Disapproved" &&
          <div className="justify-center mt-20">
            <MainButton className="mg-10" background="#E76464" title="ไม่อนุมัติ/Disapproved" onClick={() => disapproved()} />
            <MainButton
              className="mg-10"
              title="บันทึกและอนุมัติ/
              Save and Approve"
              onClick={() => {
                approver()
              }}
            />
          </div>
        }

      </div>
    </>
  );

};
export default ReplyApprover;
